import { useState, useCallback, useMemo } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";

// Loads the design docs tree and mints per-file signed URLs (content is pulled straight from S3)
const useDesignDocs = () => {
    const axiosConfig = useMemo(() => ({ showErrorToast: true }), []);
    const { getData, isLoading } = useAxios(axiosConfig);
    const [tree, setTree] = useState([]);

    const loadTree = useCallback(async () => {
        const res = await getData(Constants.ApiUrl.design.tree);
        setTree(res?.data?.tree || []);
    }, [getData]);

    const getFileUrl = useCallback(async (key) => {
        const res = await getData(`${Constants.ApiUrl.design.fileUrl}?key=${encodeURIComponent(key)}`);
        return res?.data?.url || null;
    }, [getData]);

    return { tree, loadTree, getFileUrl, isLoading };
};

export default useDesignDocs;
